import { UserDto } from './user.dto';
import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';

export class FixReportDto extends BaseDto {
  id: number;
  merchantId: number;
  merchant?: MerchantDto;
  reporterUserId?: number;
  reporterUser: UserDto;
  reportedDatetime: Date;
  faultDescription: string;
  troubleshootingDescription?: string;
  calloutRequired: number;
  authorised: number;
  authorisedUserId?: number;
  authorisedUser?: UserDto;
}
